import { IDepartment } from "@/types/department";
import { IEmployment } from "@/types/employment";
import { IProfile } from "@/types/profile";
import { ISales } from "@/types/sales";
import { Department } from "./department";
import { Employment } from "./employment";
import moment from "moment";

export class Profile implements IProfile {
  public id = 0;
  public tel = "";
  public birthday = "";
  public gender = 0;
  public railroad = "";
  public station = "";
  public reward_lower = 0;
  public reward_upper = 0;
  public summary = "";
  public memo = "";
  public recruiting = false;
  public charge_id = 0;
  public employment_id = 0;
  public department_id = 0;
  public member_id = 0;
  public company_id = 0;
  public created_at = "";
  public updated_at = "";
  public deleted_at = "";

  public charge?: ISales;
  public department: IDepartment = new Department();
  public employment: IEmployment = new Employment();

  public constructor(props?: IProfile) {
    if (!props) {
      return;
    }
    Object.assign(this, props);

    this.department = new Department(props.department);
    this.employment = new Employment(props.employment);
  }
}
